// src/services/salesEstimateService.js
import apiClient from './API';

// --- BASKET CRUD ---
export const listSalesEstimateBaskets = async (accountId) => {
    const params = accountId ? { accountId } : {};
    const response = await apiClient.get('/sales-estimate/baskets', { params });
    return response.data;
};

export const getSalesEstimateBasket = async (id) => {
    const response = await apiClient.get(`/sales-estimate/baskets/${id}`);
    return response.data;
};

export const createSalesEstimateBasket = async (basket) => {
    const response = await apiClient.post('/sales-estimate/baskets', basket);
    return response.data;
};

export const updateSalesEstimateBasket = async (id, basket) => {
    const response = await apiClient.put(`/sales-estimate/baskets/${id}`, basket);
    return response.data;
};

export const deleteSalesEstimateBasket = async (id) => {
    const response = await apiClient.delete(`/sales-estimate/baskets/${id}`);
    return response.data;
};

// --- SALES ESTIMATE QUERY ---
export const analyzeSalesEstimate = async ({ asins, basketId, marketplace = 'us', startDate, endDate }) => {
    const body = {};
    if (asins) body.asins = asins;
    if (basketId) body.basketId = basketId;
    if (marketplace) body.marketplace = marketplace;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    const response = await apiClient.post('/analysis/sales-estimate', body);
    return response.data;
};
